import {takeEvery, takeLatest, put, call, all, fork} from "redux-saga/effects"

import {
  SLIP_DETAIL,
  SLIP_SELECT,
  SLIP_UPDATE,
  SLIP_QR_UPDATE,
} from "./actionTypes"

import {
  slipDetailSuccess,
  slipDetailError,
  slipSelectSuccess,
  slipSelectError,
  slipUpdateSuccess,
  slipUpdateError,
  slipQRUpdateSuccess,
  slipQRUpdateError,
} from "./actions"

import {
  apiGetSlipDetail,
  apiGetSlipSelect,
  apiPostSlipUpdate,
  apiPostSlipQRUpdate,
} from "../../api/calls/slip"

function* slipDetail({payload: data}) {
  try {
    const response = yield call(apiGetSlipDetail, data)
    yield put(slipDetailSuccess(response))
  } catch (error) {
    yield put(slipDetailError(error))
  }
}

function* slipSelect({payload: data}) {
  try {
    const response = yield call(apiGetSlipSelect, data)
    yield put(slipSelectSuccess(response))
  } catch (error) {
    yield put(slipSelectError(error))
  }
}

function* slipUpdate({payload: data}) {
  try {
    const response = yield call(apiPostSlipUpdate, data)
    yield put(slipUpdateSuccess(response))
  } catch (error) {
    yield put(slipUpdateError(error))
  }
}

function* slipQRUpdate({payload: data}) {
  try {
    const response = yield call(apiPostSlipQRUpdate, data)
    yield put(slipQRUpdateSuccess(response))
  } catch (error) {
    yield put(slipQRUpdateError(error))
  }
}

export function* watchSlipDetail() {
  yield takeLatest(SLIP_DETAIL, slipDetail);
}

export function* watchSlipSelect() {
  yield takeLatest(SLIP_SELECT, slipSelect);
}

export function* watchSlipUpdate() {
  yield takeEvery(SLIP_UPDATE, slipUpdate);
}

export function* watchSlipQRUpdate() {
  yield takeEvery(SLIP_QR_UPDATE, slipQRUpdate);
}

function* slipSaga() {
  yield all([
    fork(watchSlipDetail),
    fork(watchSlipSelect),
    fork(watchSlipUpdate),
    fork(watchSlipQRUpdate),
  ]);
}

export default slipSaga
